import { useMutation, UseMutationResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { formatResponse } from "../../utils/FormatUtils";

export function useEditBlockedTimeSlotItemMutation(): UseMutationResult<unknown, Error> {
  return useMutation((data) =>
    httpClient.put(ApiRoutes.BlockedTimeSlotItem, { data }).then(formatResponse),
  );
}
